// extracted by mini-css-extract-plugin
export default {"content":"AgentToolSidePanel_content__WOS-a","cutText":"AgentToolSidePanel_cutText__NG6AB","header":"AgentToolSidePanel_header__Fla9E","search":"AgentToolSidePanel_search__3tZ5v"};